import { ref } from 'vue';

const locationId = ref<number>(0);

export function resetSelectedLocation(): void {
  locationId.value = 0;
}

export function useSelectedLocation() {
  return { locationId };
}
